import styled from '../../theme'

const Label = styled.div`
  margin: 0px 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default Label
